<svelte:options customElement="dst-snackbar" />

<script lang="ts">
	import { snackBar } from '@/config.ts';
	import { afterUpdate, beforeUpdate, onDestroy, onMount } from 'svelte';
	import { fade } from 'svelte/transition';

	const { fadeIn, fadeOut } = snackBar;
	export let snackbarmessage: string;

	let snackbarQueue: string[] = [];

	onMount(() => {
		window.addEventListener('message', handleMessage);
	});

	onDestroy(() => {
		window.removeEventListener('message', handleMessage);
	});

	beforeUpdate(() => {
		if (snackbarmessage) {
			snackbarQueue = [...snackbarQueue, snackbarmessage];
			snackbarmessage = '';
		}
	});

	afterUpdate(() => {
		if (snackbarQueue?.length) {
			setTimeout(() => {
				snackbarQueue.shift();
				snackbarQueue = snackbarQueue;
			}, snackBar.fadeOut.duration + snackBar.fadeOut.delay);
		}
	});

	/**
	 * Handle the message event used to trigger a snackbar message.
	 * @param event The message event.
	 */
	function handleMessage(event: MessageEvent) {
		if (event.data?.eventName !== 'snackbar:message' || typeof event.data?.payload?.message !== 'string') {
			return;
		}

		snackbarmessage = event.data.payload.message;
	}
</script>

<!-- There are inline styles because this new webcomponent supports queues (multiple message displayed at once)
  and therefore differs from the original implementation in community-feed -->
<div class="snackbar-outer" role="status">
	{#each snackbarQueue as message}
		<div
			class="snackbar"
			in:fade={{ duration: fadeIn.duration }}
			out:fade={{ delay: fadeOut.delay, duration: fadeOut.duration }}
		>
			<div>
				{message}
			</div>
		</div>
	{/each}
</div>

<style lang="scss" global>
	@use './DstSnackbar.scss';
</style>
